import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Text } from '@chatsdet/ui';
type SuperadminOnlyProps = {
  children: React.ReactNode;
  className?: string;
};

export function SuperadminOnly({ children, className }: SuperadminOnlyProps) {
  const { user } = useAuth();

  if (!user?.isSuperadmin) {
    return null;
  }

  return (
    <div className={className}>
      <Text size="xs" className="text-muted-foreground uppercase tracking-wide mb-1">
        Superadmin only
      </Text>
      {children}
    </div>
  );
}
